const TEST_STRING = 'PXP Test Build';

export default function () {
    return <div>{TEST_STRING}</div>
}
